// Rexel API Types

export enum RexelFileDiscoveryJobStatus {
  pending = 'pending',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
}

export enum RexelFileProcessingJobStatus {
  pending = 'pending',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
  cancelled = 'cancelled',
}

export interface RexelFileDiscoveryJob {
  id: string;
  status: RexelFileDiscoveryJobStatus;
  containerName: string;
  lastCheckedTimestamp: string | null;
  filesDiscovered: number | null;
  filesQueued: number | null;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface RexelFileProcessingJob {
  id: string;
  status: RexelFileProcessingJobStatus;
  containerName: string;
  blobName: string;
  fileName: string;
  fileTimestamp: string | null;
  totalRows: number | null;
  processedRows: number | null;
  anomalousRows: number | null;
  insertedRows: number | null;
  startedAt: string | null;
  completedAt: string | null;
  errorMessage: string | null;
  retryCount: number;
  maxRetries: number;
  createdAt: string;
  updatedAt: string;
  progress?: number | null;
  durationSeconds?: number | null;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

export interface DiscoveryJobsQuery {
  page?: number;
  limit?: number;
  status?: RexelFileDiscoveryJobStatus;
  containerName?: string;
  sortBy?: 'createdAt' | 'startedAt' | 'completedAt';
  sortOrder?: 'ASC' | 'DESC';
}

export interface ProcessingJobsQuery {
  page?: number;
  limit?: number;
  status?: RexelFileProcessingJobStatus;
  containerName?: string;
  fileName?: string;
  sortBy?: 'createdAt' | 'startedAt' | 'completedAt' | 'fileName';
  sortOrder?: 'ASC' | 'DESC';
}

export interface TriggerFileDiscoveryRequest {
  containerName?: string;
  priority?: 'high' | 'normal' | 'low';
}

export interface TriggerFileDiscoveryResponse {
  success: boolean;
  message: string;
  containerName: string;
  priority: 'high' | 'normal' | 'low';
  timestamp: string;
}

export interface RetryJobResponse {
  success: boolean;
  message: string;
  job: {
    id: string;
    fileName: string;
    status: RexelFileProcessingJobStatus;
    retryCount: number;
    maxRetries: number;
  };
}
